import { useColor } from "color-thief-react";
import { useEffect } from "react";

/**
 * 이미지의 주요 색상을 추출하여 document.documentElement.style에 적용하는 훅
 * @param imageUrl - 이미지 URL
 */
function useDominantColor(imageUrl: string): void {
  // React Hook to use get color from img url
  const color = useColor(imageUrl, "hslArray", {
    crossOrigin: "strict-origin-when-cross-origin",
    quality: 1,
  });

  useEffect(() => {
    if (!color.data) return;

    const { data } = color;
    const h = Number(data[0]);
    let s = Number(data[1]);
    let l = Number(data[2]);

    if (l >= 70) {
      l = 65;
    }

    if (s >= 10 && s < 80) {
      s = 80;
    }

    document.documentElement.style.setProperty("--dominant", `${h}, ${s}%, ${l}%`);
  }, [color]);
}

export default useDominantColor;
